/**
 * Supplementary budget requests (FSD 2.2.5 FIN-F06 V07): the register, the request form and
 * a request's detail with its value-banded approval chain.
 */

import type { RouteRecordRaw } from 'vue-router'

import { BUDGET_SUPPLEMENTARY_PERMISSIONS } from '@/modules/budget/supplementary/permissions'

export const BUDGET_SUPPLEMENTARY_ROUTES: RouteRecordRaw[] = [
  {
    path: '/budget/supplementary',
    name: 'budget-supplementary',
    component: () => import('@/modules/budget/supplementary/SupplementaryListView.vue'),
    meta: {
      titleKey: 'budget.routeTitles.budgetSupplementary',
      permission: BUDGET_SUPPLEMENTARY_PERMISSIONS.read,
    },
  },
  {
    path: '/budget/supplementary/new',
    name: 'budget-supplementary-new',
    component: () => import('@/modules/budget/supplementary/SupplementaryRequestView.vue'),
    meta: {
      titleKey: 'budget.routeTitles.budgetSupplementaryNew',
      permission: BUDGET_SUPPLEMENTARY_PERMISSIONS.request,
    },
  },
  {
    path: '/budget/supplementary/:id(\\d+)',
    name: 'budget-supplementary-request',
    component: () => import('@/modules/budget/supplementary/SupplementaryView.vue'),
    meta: {
      titleKey: 'budget.routeTitles.budgetSupplementaryRequest',
      permission: BUDGET_SUPPLEMENTARY_PERMISSIONS.read,
    },
  },
]

export function supplementaryRoute(id: number): string {
  return `/budget/supplementary/${id}`
}

export function supplementaryNewRoute(companyId?: number | null): string {
  return companyId === undefined || companyId === null
    ? '/budget/supplementary/new'
    : `/budget/supplementary/new?companyId=${companyId}`
}
